import {types} from '../../types';

const setGetReplenishmentAction = (payload) => {
    return {
        type: types.replenishment.SET_REPLENISHMENT,
        payload,
      }
}

export {
  setGetReplenishmentAction as SetGetReplenishmentAction
}
